package ch.wsl.typings.choicesJs.anon

import ch.wsl.typings.choicesJs.choicesJsStrings.always
import ch.wsl.typings.choicesJs.choicesJsStrings.auto
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoicesMod.Choices
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesPositionOptionsTypeMod.PositionOptionsType
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesTypesMod.Types.FilterFunction
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesTypesMod.Types.NoticeLimitFunction
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesTypesMod.Types.NoticeStringFunction
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesTypesMod.Types.StrToEl
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesTypesMod.Types.StringFunction
import ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesTypesMod.Types.ValueCompareFunction
import ch.wsl.typings.fuseJs.mod.Fuse.IFuseOptions
import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

/* Inlined std.Partial<choices.js.choices.js/public/types/src/scripts/interfaces/options.Options> */
@js.native
trait PartialOptions extends StObject {
  
  var addItemFilter: js.UndefOr[String | js.RegExp | FilterFunction | Null] = js.native
  
  var addItemText: js.UndefOr[String | NoticeStringFunction] = js.native
  
  var addItems: js.UndefOr[Boolean] = js.native
  
  var allowHTML: js.UndefOr[Boolean] = js.native
  
  var appendValue: js.UndefOr[String | Null] = js.native
  
  var callbackOnCreateTemplates: js.UndefOr[(js.Function1[/* template */ StrToEl, Unit]) | Null] = js.native
  
  var callbackOnInit: js.UndefOr[(js.ThisFunction0[/* this */ Choices, Unit]) | Null] = js.native
  
  var choices: js.UndefOr[
    js.Array[ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice]
  ] = js.native
  
  var classNames: js.UndefOr[ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesClassNamesMod.ClassNames] = js.native
  
  var customAddItemText: js.UndefOr[String | NoticeStringFunction] = js.native
  
  var delimiter: js.UndefOr[String] = js.native
  
  var duplicateItemsAllowed: js.UndefOr[Boolean] = js.native
  
  var editItems: js.UndefOr[Boolean] = js.native
  
  var fuseOptions: js.UndefOr[IFuseOptions[Choices]] = js.native
  
  var itemSelectText: js.UndefOr[String] = js.native
  
  var items: js.UndefOr[
    js.Array[
      ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice | String
    ]
  ] = js.native
  
  var labelId: js.UndefOr[String] = js.native
  
  var loadingText: js.UndefOr[String] = js.native
  
  var maxItemCount: js.UndefOr[Double] = js.native
  
  var maxItemText: js.UndefOr[String | NoticeLimitFunction] = js.native
  
  var noChoicesText: js.UndefOr[String | StringFunction] = js.native
  
  var noResultsText: js.UndefOr[String | StringFunction] = js.native
  
  var paste: js.UndefOr[Boolean] = js.native
  
  var placeholder: js.UndefOr[Boolean] = js.native
  
  var placeholderValue: js.UndefOr[String | Null] = js.native
  
  var position: js.UndefOr[PositionOptionsType] = js.native
  
  var prependValue: js.UndefOr[String | Null] = js.native
  
  var removeItemButton: js.UndefOr[Boolean] = js.native
  
  var removeItems: js.UndefOr[Boolean] = js.native
  
  var renderChoiceLimit: js.UndefOr[Double] = js.native
  
  var renderSelectedChoices: js.UndefOr[auto | always] = js.native
  
  var resetScrollPosition: js.UndefOr[Boolean] = js.native
  
  var searchChoices: js.UndefOr[Boolean] = js.native
  
  var searchEnabled: js.UndefOr[Boolean] = js.native
  
  var searchFields: js.UndefOr[js.Array[String]] = js.native
  
  var searchFloor: js.UndefOr[Double] = js.native
  
  var searchPlaceholderValue: js.UndefOr[String | Null] = js.native
  
  var searchResultLimit: js.UndefOr[Double] = js.native
  
  var shouldSort: js.UndefOr[Boolean] = js.native
  
  var shouldSortItems: js.UndefOr[Boolean] = js.native
  
  var silent: js.UndefOr[Boolean] = js.native
  
  var sorter: js.UndefOr[
    js.Function2[
      /* current */ ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice, 
      /* next */ ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice, 
      Double
    ]
  ] = js.native
  
  var uniqueItemText: js.UndefOr[String | NoticeStringFunction] = js.native
  
  var valueComparer: js.UndefOr[ValueCompareFunction] = js.native
}
object PartialOptions {
  
  @scala.inline
  def apply(): PartialOptions = {
    val __obj = js.Dynamic.literal()
    __obj.asInstanceOf[PartialOptions]
  }
  
  @scala.inline
  implicit class MutableBuilder[Self <: PartialOptions] (val x: Self) extends AnyVal {
    
    @scala.inline
    def setAddItemFilter(value: String | js.RegExp | FilterFunction): Self = StObject.set(x, "addItemFilter", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAddItemFilterFunction1(value: /* value */ String => Boolean): Self = StObject.set(x, "addItemFilter", js.Any.fromFunction1(value))
    
    @scala.inline
    def setAddItemFilterNull: Self = StObject.set(x, "addItemFilter", null)
    
    @scala.inline
    def setAddItemFilterUndefined: Self = StObject.set(x, "addItemFilter", js.undefined)
    
    @scala.inline
    def setAddItemText(value: String | NoticeStringFunction): Self = StObject.set(x, "addItemText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAddItemTextFunction1(value: /* value */ String => String): Self = StObject.set(x, "addItemText", js.Any.fromFunction1(value))
    
    @scala.inline
    def setAddItemTextUndefined: Self = StObject.set(x, "addItemText", js.undefined)
    
    @scala.inline
    def setAddItems(value: Boolean): Self = StObject.set(x, "addItems", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAddItemsUndefined: Self = StObject.set(x, "addItems", js.undefined)
    
    @scala.inline
    def setAllowHTML(value: Boolean): Self = StObject.set(x, "allowHTML", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAllowHTMLUndefined: Self = StObject.set(x, "allowHTML", js.undefined)
    
    @scala.inline
    def setAppendValue(value: String): Self = StObject.set(x, "appendValue", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAppendValueNull: Self = StObject.set(x, "appendValue", null)
    
    @scala.inline
    def setAppendValueUndefined: Self = StObject.set(x, "appendValue", js.undefined)
    
    @scala.inline
    def setCallbackOnCreateTemplates(value: /* template */ StrToEl => Unit): Self = StObject.set(x, "callbackOnCreateTemplates", js.Any.fromFunction1(value))
    
    @scala.inline
    def setCallbackOnCreateTemplatesNull: Self = StObject.set(x, "callbackOnCreateTemplates", null)
    
    @scala.inline
    def setCallbackOnCreateTemplatesUndefined: Self = StObject.set(x, "callbackOnCreateTemplates", js.undefined)
    
    @scala.inline
    def setCallbackOnInit(value: js.ThisFunction0[/* this */ Choices, Unit]): Self = StObject.set(x, "callbackOnInit", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setCallbackOnInitNull: Self = StObject.set(x, "callbackOnInit", null)
    
    @scala.inline
    def setCallbackOnInitUndefined: Self = StObject.set(x, "callbackOnInit", js.undefined)
    
    @scala.inline
    def setChoices(value: js.Array[ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice]): Self = StObject.set(x, "choices", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setChoicesUndefined: Self = StObject.set(x, "choices", js.undefined)
    
    @scala.inline
    def setChoicesVarargs(value: ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice*): Self = StObject.set(x, "choices", js.Array(value :_*))
    
    @scala.inline
    def setClassNames(value: ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesClassNamesMod.ClassNames): Self = StObject.set(x, "classNames", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setClassNamesUndefined: Self = StObject.set(x, "classNames", js.undefined)
    
    @scala.inline
    def setCustomAddItemText(value: String | NoticeStringFunction): Self = StObject.set(x, "customAddItemText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setCustomAddItemTextFunction1(value: /* value */ String => String): Self = StObject.set(x, "customAddItemText", js.Any.fromFunction1(value))
    
    @scala.inline
    def setCustomAddItemTextUndefined: Self = StObject.set(x, "customAddItemText", js.undefined)
    
    @scala.inline
    def setDelimiter(value: String): Self = StObject.set(x, "delimiter", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setDelimiterUndefined: Self = StObject.set(x, "delimiter", js.undefined)
    
    @scala.inline
    def setDuplicateItemsAllowed(value: Boolean): Self = StObject.set(x, "duplicateItemsAllowed", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setDuplicateItemsAllowedUndefined: Self = StObject.set(x, "duplicateItemsAllowed", js.undefined)
    
    @scala.inline
    def setEditItems(value: Boolean): Self = StObject.set(x, "editItems", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setEditItemsUndefined: Self = StObject.set(x, "editItems", js.undefined)
    
    @scala.inline
    def setFuseOptions(value: IFuseOptions[Choices]): Self = StObject.set(x, "fuseOptions", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setFuseOptionsUndefined: Self = StObject.set(x, "fuseOptions", js.undefined)
    
    @scala.inline
    def setItemSelectText(value: String): Self = StObject.set(x, "itemSelectText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setItemSelectTextUndefined: Self = StObject.set(x, "itemSelectText", js.undefined)
    
    @scala.inline
    def setItems(
      value: js.Array[
          ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice | String
        ]
    ): Self = StObject.set(x, "items", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setItemsUndefined: Self = StObject.set(x, "items", js.undefined)
    
    @scala.inline
    def setItemsVarargs(value: (ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice | String)*): Self = StObject.set(x, "items", js.Array(value :_*))
    
    @scala.inline
    def setLabelId(value: String): Self = StObject.set(x, "labelId", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setLabelIdUndefined: Self = StObject.set(x, "labelId", js.undefined)
    
    @scala.inline
    def setLoadingText(value: String): Self = StObject.set(x, "loadingText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setLoadingTextUndefined: Self = StObject.set(x, "loadingText", js.undefined)
    
    @scala.inline
    def setMaxItemCount(value: Double): Self = StObject.set(x, "maxItemCount", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMaxItemCountUndefined: Self = StObject.set(x, "maxItemCount", js.undefined)
    
    @scala.inline
    def setMaxItemText(value: String | NoticeLimitFunction): Self = StObject.set(x, "maxItemText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMaxItemTextFunction1(value: /* maxItemCount */ Double => String): Self = StObject.set(x, "maxItemText", js.Any.fromFunction1(value))
    
    @scala.inline
    def setMaxItemTextUndefined: Self = StObject.set(x, "maxItemText", js.undefined)
    
    @scala.inline
    def setNoChoicesText(value: String | StringFunction): Self = StObject.set(x, "noChoicesText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setNoChoicesTextFunction0(value: () => String): Self = StObject.set(x, "noChoicesText", js.Any.fromFunction0(value))
    
    @scala.inline
    def setNoChoicesTextUndefined: Self = StObject.set(x, "noChoicesText", js.undefined)
    
    @scala.inline
    def setNoResultsText(value: String | StringFunction): Self = StObject.set(x, "noResultsText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setNoResultsTextFunction0(value: () => String): Self = StObject.set(x, "noResultsText", js.Any.fromFunction0(value))
    
    @scala.inline
    def setNoResultsTextUndefined: Self = StObject.set(x, "noResultsText", js.undefined)
    
    @scala.inline
    def setPaste(value: Boolean): Self = StObject.set(x, "paste", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setPasteUndefined: Self = StObject.set(x, "paste", js.undefined)
    
    @scala.inline
    def setPlaceholder(value: Boolean): Self = StObject.set(x, "placeholder", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setPlaceholderUndefined: Self = StObject.set(x, "placeholder", js.undefined)
    
    @scala.inline
    def setPlaceholderValue(value: String): Self = StObject.set(x, "placeholderValue", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setPlaceholderValueNull: Self = StObject.set(x, "placeholderValue", null)
    
    @scala.inline
    def setPlaceholderValueUndefined: Self = StObject.set(x, "placeholderValue", js.undefined)
    
    @scala.inline
    def setPosition(value: PositionOptionsType): Self = StObject.set(x, "position", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setPositionUndefined: Self = StObject.set(x, "position", js.undefined)
    
    @scala.inline
    def setPrependValue(value: String): Self = StObject.set(x, "prependValue", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setPrependValueNull: Self = StObject.set(x, "prependValue", null)
    
    @scala.inline
    def setPrependValueUndefined: Self = StObject.set(x, "prependValue", js.undefined)
    
    @scala.inline
    def setRemoveItemButton(value: Boolean): Self = StObject.set(x, "removeItemButton", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setRemoveItemButtonUndefined: Self = StObject.set(x, "removeItemButton", js.undefined)
    
    @scala.inline
    def setRemoveItems(value: Boolean): Self = StObject.set(x, "removeItems", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setRemoveItemsUndefined: Self = StObject.set(x, "removeItems", js.undefined)
    
    @scala.inline
    def setRenderChoiceLimit(value: Double): Self = StObject.set(x, "renderChoiceLimit", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setRenderChoiceLimitUndefined: Self = StObject.set(x, "renderChoiceLimit", js.undefined)
    
    @scala.inline
    def setRenderSelectedChoices(value: auto | always): Self = StObject.set(x, "renderSelectedChoices", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setRenderSelectedChoicesUndefined: Self = StObject.set(x, "renderSelectedChoices", js.undefined)
    
    @scala.inline
    def setResetScrollPosition(value: Boolean): Self = StObject.set(x, "resetScrollPosition", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setResetScrollPositionUndefined: Self = StObject.set(x, "resetScrollPosition", js.undefined)
    
    @scala.inline
    def setSearchChoices(value: Boolean): Self = StObject.set(x, "searchChoices", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSearchChoicesUndefined: Self = StObject.set(x, "searchChoices", js.undefined)
    
    @scala.inline
    def setSearchEnabled(value: Boolean): Self = StObject.set(x, "searchEnabled", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSearchEnabledUndefined: Self = StObject.set(x, "searchEnabled", js.undefined)
    
    @scala.inline
    def setSearchFields(value: js.Array[String]): Self = StObject.set(x, "searchFields", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSearchFieldsUndefined: Self = StObject.set(x, "searchFields", js.undefined)
    
    @scala.inline
    def setSearchFieldsVarargs(value: String*): Self = StObject.set(x, "searchFields", js.Array(value :_*))
    
    @scala.inline
    def setSearchFloor(value: Double): Self = StObject.set(x, "searchFloor", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSearchFloorUndefined: Self = StObject.set(x, "searchFloor", js.undefined)
    
    @scala.inline
    def setSearchPlaceholderValue(value: String): Self = StObject.set(x, "searchPlaceholderValue", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSearchPlaceholderValueNull: Self = StObject.set(x, "searchPlaceholderValue", null)
    
    @scala.inline
    def setSearchPlaceholderValueUndefined: Self = StObject.set(x, "searchPlaceholderValue", js.undefined)
    
    @scala.inline
    def setSearchResultLimit(value: Double): Self = StObject.set(x, "searchResultLimit", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSearchResultLimitUndefined: Self = StObject.set(x, "searchResultLimit", js.undefined)
    
    @scala.inline
    def setShouldSort(value: Boolean): Self = StObject.set(x, "shouldSort", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setShouldSortItems(value: Boolean): Self = StObject.set(x, "shouldSortItems", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setShouldSortItemsUndefined: Self = StObject.set(x, "shouldSortItems", js.undefined)
    
    @scala.inline
    def setShouldSortUndefined: Self = StObject.set(x, "shouldSort", js.undefined)
    
    @scala.inline
    def setSilent(value: Boolean): Self = StObject.set(x, "silent", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSilentUndefined: Self = StObject.set(x, "silent", js.undefined)
    
    @scala.inline
    def setSorter(
      value: (/* current */ ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice, /* next */ ch.wsl.typings.choicesJs.publicTypesSrcScriptsInterfacesChoiceMod.Choice) => Double
    ): Self = StObject.set(x, "sorter", js.Any.fromFunction2(value))
    
    @scala.inline
    def setSorterUndefined: Self = StObject.set(x, "sorter", js.undefined)
    
    @scala.inline
    def setUniqueItemText(value: String | NoticeStringFunction): Self = StObject.set(x, "uniqueItemText", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setUniqueItemTextFunction1(value: /* value */ String => String): Self = StObject.set(x, "uniqueItemText", js.Any.fromFunction1(value))
    
    @scala.inline
    def setUniqueItemTextUndefined: Self = StObject.set(x, "uniqueItemText", js.undefined)
    
    @scala.inline
    def setValueComparer(value: (/* value1 */ String, /* value2 */ String) => Boolean): Self = StObject.set(x, "valueComparer", js.Any.fromFunction2(value))
    
    @scala.inline
    def setValueComparerUndefined: Self = StObject.set(x, "valueComparer", js.undefined)
  }
}
